import { styled } from "@mui/material"

export const StyledContainer = styled("div")`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`
